<datalist id="system-pages">
    <option value="Accounts" data-path="/accounts"></option>
    <option value="Collections" data-path="/collections"></option>
    @if (security.permitted('corporation setup', 'corporate list', 'view')) {
        <option value="Company Setup" data-path="/settings/corporations"></option>
    }
    @if (security.permitted('contacts', 'contact list', 'view')) {
        <option value="Contacts" data-path="/contacts"></option>
    }
    @if (security.permitted('users', 'user list', 'view')) {
        <option value="Employees" data-path="/settings/employees"></option>
    }
    <option value="GPS Devices" data-path="/settings/gps"></option>
    @if (security.permitted('corporation setup', 'corporate integrations', 'view')) {
        <option value="Integrations" data-path="/settings/integration"></option>
    }
    @if (security.permitted('inventory', 'inventory list', 'view')) {
        <option value="Inventory" data-path="/inventory"></option>
    }
    @if (security.permitted('sales', 'sale list', 'view')) {
        <option value="Quotes" data-path="/quotes"></option>
    }
    <option value="Reports" data-path="/reports"></option>
    @if (security.permitted('sales', 'sale list', 'view')) {
        <option value="Sales" data-path="/sales"></option>
    }
    <option value="Service" data-path="/service"></option>
    @if (security.permitted('users', 'user list', 'view')) {
        <option value="Users" data-path="/settings/users"></option>
    }
</datalist>

<div class="navbar-custom text-dark" [ngClass]="{'no-sidebar': !sideBar}">
    <ul class="list-unstyled topbar-right-menu float-right mb-0 d-flex align-items-center">
        <!-- search -->
        <li class="dropdown notification-list d-lg-none">
            <a class="nav-link dropdown-toggle arrow-none" data-toggle="dropdown" href="#" role="button"
                aria-haspopup="false" aria-expanded="false">
                <span class="dripicons-search noti-icon"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-animated dropdown-sm p-0">
                <form class="p-3">
                    <input type="search" class="form-control form-control-sm" placeholder="{{words.language[languageSelect].search}} ..." aria-label="Find something" />
                </form>
            </div>
        </li>
        <!-- lots -->
        <li>
            <div class="align-items-center mx-2">
                <select class=" form-control form-control-sm mb-0 border-0" [(ngModel)]="lotSelected"
                    (change)="changeLot(lotSelected)" id="lots">
                    <optgroup label="{{words.language[languageSelect].selectALot}}">
                        @for (lot of lots; track lot) {
                        <option [value]="lot.id">{{lot.contact.name}}</option>
                        }
                    </optgroup>
                </select>
            </div>
        </li>
        <!-- language -->
        <li class="d-flex align-items-center">
            <img [src]="image" alt="user-image" class="mr-0 mr-sm-1" height="12">
            <select class="form-control-sm ml-2 form-control" (change)="changeLanguage(languageSelect)" [(ngModel)]="languageSelect">
                @for (language of languages; track language) {
                    <option [value]="language.value">{{words.language[languageSelect][language.name] }}</option>
                }
            </select>
        </li>
        <!-- Support -->
        <li class="dropdown notification-list topbar-dropdown">
            <a class="nav-link dropdown-toggle arrow-none" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                <span class="uil-headphones mr-0 mr-sm-1 text-dark"></span>
                <span class="align-middle d-none d-sm-inline-block text-dark">{{words.language[languageSelect].support}}</span>
                <span class="mdi mdi-chevron-down d-none d-sm-inline-block align-middle text-dark"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-animated topbar-dropdown-menu">
                <!-- Support Code-->
                <p class="dropdown-item">{{words.language[languageSelect].corporationId}}: {{user.corporateId}}</p>
                <div class="dropdown-divider"></div>
                
                <!-- SOS -->
                <a href="https://sos.splashtop.com" target="_blank" class="dropdown-item">{{words.language[languageSelect].Splashtop}}</a>

                <!-- Support Center -->
                <a href="/help" target="_blank" class="dropdown-item">{{words.language[languageSelect].supportCenter}}</a>
                <div class="dropdown-divider"></div>

                <p class="dropdown-item text-muted">version {{version}}</p>
            </div>
        </li>
        <li class="dropdown notification-list text-dark">
            <a class="nav-link dropdown-toggle nav-user arrow-none mr-0" data-toggle="dropdown" href="#" role="button"
                aria-haspopup="false" aria-expanded="false">
                <span class="account-user-avatar">
                    <img src="../../../assets/images/users/avatar.svg" alt="user-image" class="rounded-circle">
                </span>
                <span>
                    <span class="account-user-name text-dark">{{user.firstName}} {{user.lastName}}</span>
                </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-animated topbar-dropdown-menu profile-dropdown">
                <a class="dropdown-item notify-item" [routerLink]="['/profile']" routerLinkActive="font-weight-bold">
                    <span class="material-icons-outlined mr-1">account_circle</span>
                    <span class="text-dark"> {{words.language[languageSelect].myProfile}}</span>
                </a>

                <a href="javascript:void(0);" class="dropdown-item notify-item" (click)="toggleTheme()">
                    <span class="material-icons-outlined mr-1">contrast</span>
                    <span>Switch to {{theme === 'light' ? 'dark' : 'light'}} theme</span>
                </a>

                <a href="javascript:void(0);" class="dropdown-item notify-item" (click)="logout()">
                    <span class="material-icons-outlined mr-1">exit_to_app</span>
                    <span>{{words.language[languageSelect].logout}} </span>
                </a>
            </div>
        </li>

    </ul>
    <button class="button-menu-mobile open-left disable-btn">
        <span class="mdi mdi-menu"></span>
    </button>
    <div class="app-search dropdown d-none" [ngClass]="{'d-lg-block': sideBar}">
        <form>
            <div class="input-group">
                <input type="search" list="system-pages" class="form-control form-control-sm" placeholder="{{words.language[languageSelect].search}}..." id="top-search" (change)="navigate($event)" />
                <span class="mdi mdi-magnify search-icon"></span>
            </div>
        </form>
    </div>
</div>
